import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import activityKindPresentation from '~tread-agent/trace/activityKindPresentation';
import { TreadAgentTraceStep } from '~tread-agent/types';

interface TraceStepRowProps {
  step: TreadAgentTraceStep;
}

export default function TraceStepRow({ step }: TraceStepRowProps) {
  const theme = useTheme();
  const { Icon, label } = activityKindPresentation(step.activityKind);
  const phrase = step.activity ?? label;

  return (
    <Box
      data-test-id={`tread-agent-trace-step-${step.activityKind}`}
      sx={{ alignItems: 'center', display: 'flex', gap: 0.5, minWidth: 0 }}
    >
      <Icon
        aria-label={label}
        role="img"
        sx={{
          color: theme.brandV2.colors.treadGray2,
          fontSize: 16,
        }}
      />

      <Typography
        sx={{
          color: theme.brandV2.colors.treadGray1,
          fontSize: '12px',
          fontWeight: 500,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {phrase}
      </Typography>
    </Box>
  );
}
